module.exports = __webpack_public_path__ + "static/media/doubleDoor180.92e9c479.png";